import { createRouter, createWebHashHistory } from "vue-router";
import Layout from "../views/Layouts/index.vue";
import { h, resolveComponent } from "vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Layout,
    redirect: "/index",
    children: [],
  },
  {
    path: "/login/:type?",
    name: "Login",
    meta: {
      title: "登录页",
    },
    component: () => import("../views/login.vue"),
  },
  {
    path: "/index",
    name: "Index",
    meta: {
      title: "首页",
    },
    component: () => import("../views/index.vue"),
  },
  {
    path: "/word",
    name: "Word",
    meta: {
      title: "背单词",
    },
    component: () => import("../views/word.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
